import { Link, useParams } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import { Button } from "react-bootstrap";
import { useQuery } from "react-query";

import CourseCard from "../components/CourseCard";
import Loader from "../../../components/Loader";

import { getCourse } from "../../../services/wp.course.query";

export const MyAccountMyCourse = () => {
	const params = useParams();
	const {
		data: course,
		isLoading
	} = getCourse(useQuery, params.courseId);

	return isLoading
		? <Loader />
		: (
			<>
				<div>
					<Button as={Link} to="/account/classes" variant="link">
						<ArrowLeftIcon className="i me-2" />
						Back to My Classes
					</Button>
				</div>

				<hr />

				<CourseCard course={course} showDescription />
			</>
		);
};

export default MyAccountMyCourse;
